import React, {useEffect, useState} from 'react';
import * as AXIOS from '../../../services/departmentService';
import Swal from 'sweetalert2';
import {getLanguage, t} from 'react-switch-lang';
import {Edit} from '../../../components/modals/ModalEdit';
import {searchDepartments} from './SearchDepartments';
import {Show} from '../../../components/modals/ModalShow';
import {Add} from '../../../components/modals/ModalAdd';
import Loader from '../../../components/loader/Loader';
import TableAdministration from '../../../components/tablesAdministration/Table-administration';
import {Delete} from '../../../components/modals/ModalDelete';
import SearchHeader from './pageHeader/PageHeader';

const Departments = () => {

  const [items, setItems] = useState([]);
  const [filterItems, setFilterItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState('');
  const [rowChanged, setRowChanged] = useState(false);
  const [search, setSearch] = useState('');
  const [tableKey, setTableKey] = useState(0);
  const fetchData = () => {

    setIsLoading(true);
    setIsLoadingPage(true);

    AXIOS.getAllDepartments()
      .then((r) => {
        setItems(generateRows(r.data));
        setFilterItems(generateRows(r.data));
        setIsLoading(false);
        setIsLoadingPage(false);
      })
      .catch((r) => {
        setIsLoading(false);
        setIsLoadingPage(false);
        if (r.message === 'Network Error') {
          Swal.fire({
            text: `${t('message.errorServerTitle')}`,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        } else {
          Swal.fire({
            text: `${t('message.errorApi')}`,
            icon: 'error',
            confirmButtonText: 'Ok',
          });
        }
      });

  };
  const getSelectFields = (param, authorityArray) => {
    const result = [];
    if (Array.isArray(authorityArray)) {
      authorityArray.map(item => {
        result.push(item[param]);
      });
    }
    return result.length > 0 ? result.join(', ') : '';

  };
  const generateRows = (items) => {
    return items.map(item => {
        let lang;
        if (item.langKey === 'mne') {
          if (getLanguage() === 'mne') {
            lang = t('language.mneLat');
          } else {
            lang = t('language.mneLat');
          }
        } else {
          if (getLanguage() === 'eng') {
            lang = t('language.english');
          } else {
            lang = t('language.english');
          }
        }

        return {
          name: item.name,
          nameEn: item.nameEn,
          departmentTypeId: getLanguage() === 'eng' ? item?.departmentTypeNameEn : item?.departmentTypeName,
          parentId: item?.parentId ? item?.parentName : '',
          sectorDirectorId: item?.sectorDirectorId ? `${item?.sectorDirectorFirstName} ${item?.sectorDirectorLastName}` : '',
          userResponsibleId: item?.userResponsibleId ? `${item?.userResponsibleFirstName} ${item?.userResponsibleLastName}` : '',
          userInChargeId: item?.userInChargeId ? `${item?.userInChargeFirstName} ${item?.userInChargeLastName}` : '',
          userInChargeReplacementId: item?.userInChargeReplacementId ? `${item?.userInChargeReplacementFirstName} ${item?.userInChargeReplacementLastName}` : '',
          onClick: () => onRowClick(item),
          buttons: [

            <Edit data={item} id='departments'
                  setRowChanged={() => onRowChange()} />
            ,
            <Delete
              data={item}
              id='departments'
              setRowChanged={() => onRowChange()}
            />,

          ],
        };
      },
    );
  };
  const filterList = (event) => {
    const search = event.target.value;
    setSearch(search);
    setFilterItems(searchDepartments(search, items));

  };
  useEffect(() => {
    fetchData();
  }, [rowChanged]);

  const onRowClick = (item) => {
    setModalData(item);
    setModal(!modal + 1);
  };

  const onRowChange = () => {
    setRowChanged(!rowChanged);
    setSearch('');
    setTableKey(tableKey + 1);
  };
  const tableHeader = [
    t('departments.name'),
    t('departments.nameEn'),
    t('departments.departmentTypes'),
    t('departments.departments'),
    t('departments.sectorDirector'),
    t('departments.responsibleUsers'),
    t('departments.inChargeUsers'),
    t('departments.users')
  ];

  return (
    <div style={{padding: '0 30px'}} className=' h-100  pb-3'>

      <Show
        data={modalData}
        id='departments'
        type='departments'
        modal={modal}
        setModal={setModal}
        isEditable={true}
        setRowChanged={() => onRowChange()}
      />
      <SearchHeader
        placeholder={t('departments.placeholder.search')}
        button={

          <Add id='departments' setRowChanged={() => onRowChange()} />

        }

        onChange={(e) => filterList(e)}
        showInput={true}
        showButton={true}

      />

      <div
        className='position-relative administration-page-table-container pt-4'>
        {isLoadingPage && <Loader />}

        <TableAdministration
          key={tableKey}
          tableHeader={tableHeader}
          tableRows={search ? filterItems : items}
          hasMore={false}
          isLoading={isLoading}
          editableRow={false}
        />
      </div>

    </div>
  );
};

export default Departments;